import { z } from 'zod';

/**
 * Validation schema for a single department
 */
export const departmentSchema = z.object({
  departmentId: z.number(),
  name: z
    .string()
    .trim()
    .min(1, 'authenticated.settings:pages.departments.errors.nameRequired')
    .max(100, 'authenticated.settings:pages.departments.errors.nameTooLong'),
  memberCount: z.number(),
});

/**
 * Validation schema for departments form
 * Includes duplicate name validation
 */
export const departmentsFormSchema = z.object({
  departments: z.array(departmentSchema).superRefine((departments, ctx) => {
    // Check for duplicate names (case-insensitive)
    const names = new Map<string, number>();

    departments.forEach((dept, index) => {
      const normalizedName = dept.name.toLowerCase().trim();

      if (normalizedName) {
        const firstIndex = names.get(normalizedName);

        if (firstIndex !== undefined && firstIndex !== index) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'authenticated.settings:pages.departments.errors.duplicateName',
            path: [index, 'name'],
          });
        } else {
          names.set(normalizedName, index);
        }
      }
    });
  }),
});

/**
 * Validation schema for delete department modal
 */
export const deleteDepartmentSchema = z.object({
  replacementDepartmentId: z.number().optional(),
});

export type DepartmentsFormData = z.infer<typeof departmentsFormSchema>;
export type DeleteDepartmentFormData = z.infer<typeof deleteDepartmentSchema>;
